
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login-confirmation",
      function () {
        return require("private-next-pages/login-confirmation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login-confirmation"])
      });
    }
  